import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import styles from './filterCheckboxStyles.scss';

const FilterCheckbox: React.FC<{
  analyticsTag?: string;
  disabled?: boolean;
  paramName: string;
  text: string;
}> = ({ analyticsTag, disabled = false, paramName, text }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentParamValue = searchParams.get(paramName);

  const setParamValue = useCallback(
    (checked: boolean) => {
      searchParams.set('page', '1');
      if (checked) {
        searchParams.set(paramName, 'true');
      } else {
        searchParams.delete(paramName);
      }
      searchParams.delete('recommended');
      searchParams.delete('fpid');
      setSearchParams(searchParams);
    },
    [paramName, searchParams, setSearchParams]
  );

  return (
    <div className={styles.filterCheckbox}>
      <input
        type="checkbox"
        onChange={({ target: { checked } }): void => setParamValue(checked)}
        checked={Boolean(currentParamValue)}
        name={paramName}
        disabled={disabled}
        data-heap={analyticsTag}
        id={paramName}
      />
      <label htmlFor={paramName}>{text}</label>
    </div>
  );
};

export default FilterCheckbox;
